import style from './style';

const MobileVideo = props => {
    const { site } = props;

    return (
        <div class={`${style['mobile-video']} ${style[`mobile-video--${site}`]}`}>
            <div class={`${style['mobile-video__wrapper']}`}>
                    <a
                        class={`${style['mobile-video__preview']} ${style[`mv__preview--${site}`]}`}
                        href={props.url} 
                        target={'_blank'}
                    />
                <div >
                    <div className={`${style['mobile-video__title']} ${style[`mobile-video__title--${props.site}`]}`}>
                        Холивар. История Рунета. Эпизод {site}<br/><span>&#60;--Смотреть здесь!</span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MobileVideo;
